import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'linegrid',
    templateUrl: 'linegrid.component.html',
    styleUrls: ['linegrid.component.scss'],
})
export class LineGridComponent implements OnInit {
    @Input() public dataLine;
    public ngOnInit(){
        
    }
}
